<template>
	<div>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<back-button to="/devices" />
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<action-buttons
						:disabled="!editDevice.mac || !editDevice.template || !editDevice.tenant || loading"
						:save-label="editDevice.id ? 'Save' : 'Create'"
						@save="save"
						@close="routeTo('/devices')"
					/>
				</div>
			</div>

			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-lg-offset-3">
					<card-wrapper :loading="loading">
						<template #default>
							<div class="mx-auto mb-5 w-full">
								<div class="col-sm-12 textCenter">
									<div class="navAvatar margin-b10 flex w-full justify-center">
										<img src="/assets/images/teleflow-logo-black.png" width="200" />
									</div>
								</div>
							</div>

							<div v-if="editDevice.id" class="flex w-full flex-col items-center justify-center gap-2">
								<div class="flex items-center">
									<span class="fa-light fa-binary-circle-check mr-2 mt-2 text-primary"></span>
									<h1>{{ editDevice.mac.toLocaleUpperCase() }}</h1>
								</div>
							</div>
							<form-section
								v-if="
									!editDevice.id &&
									(tenants?.length > 1 || $global.hasUserRole(userRoles, 'reseller'))
								"
								title="Tenant"
							>
								<form-field label="Tenant" has-icon icon-class="fa-chevron-down" class="w-full px-2">
									<select v-model="editDevice.tenant">
										<option disabled :value="null">-- Select Tenant --</option>
										<option v-for="t in tenants" :key="t.id" :value="t">
											{{ t.companyName }}
										</option>
									</select>
								</form-field>
							</form-section>
							<form-section v-if="editDevice.tenant" title="Device Information">
								<form-field v-if="!editDevice.id" label="MAC Address" class="w-full px-2">
									<form-kit
										v-model="editDevice.mac"
										type="text"
										class="form-control"
										placeholder="00-11-22-33-44-55"
										name="MAC Address"
										:validation="'required'"
										validation-visibility="live"
									/>
								</form-field>
								<form-field label="Serial Number (optional)" class="w-full px-2">
									<form-kit
										v-model="editDevice.serial_number"
										type="text"
										class="form-control"
										placeholder="Enter serial number (optional)"
										name="Serial Number"
										validation-visibility="live"
									/>
								</form-field>
							</form-section>
							<form-section v-if="editDevice.tenant" title="Provisioning Settings">
								<form-field label="Template" has-icon icon-class="fa-chevron-down" class="w-full px-2">
									<div class="flex items-center">
										<select v-model="editDevice.template" class="flex-grow">
											<option disabled :value="null">-- Select Template --</option>
											<option v-for="t in tenantTemplates" :key="t.id" :value="t">
												{{ t.name }}
											</option>
										</select>
										<!-- <button
											v-if="editDevice.template"
											class="ml-2 rounded bg-blue-500 px-2 py-1 text-white hover:bg-blue-600"
											@click="viewTemplate"
										>
											<span class="fa-light fa-pencil mr-1"></span>
											Edit
										</button>
										<button
											v-if="
												!editDevice.template &&
												editDevice.tenant &&
												$global.hasUserRole(userRoles, 'devices:create')
											"
											class="ml-2 rounded bg-green-500 px-2 py-1 text-white hover:bg-green-600"
											@click="createTemplate"
										>
											<span class="fa-light fa-plus mr-1"></span>
											New
										</button> -->
									</div>
								</form-field>
								<form-field label="Firmware URL (optional)" class="w-full px-2">
									<form-kit
										v-model="editDevice.firmware_url"
										autocomplete="off"
										type="text"
										class="form-control"
										placeholder="Enter firmware URL (optional)"
										name="Firmware URL"
										validation-visibility="live"
									/>
								</form-field>
							</form-section>
							<form-section v-if="editDevice.tenant" title="Lines">
								<form-field label="SIP trunk(s)" class="px-2">
									<div class="my-2 mb-2">
										<button class="fab fabSm green" @click="addLine">
											<span class="fa-light fa-plus"></span>
										</button>
									</div>
								</form-field>

								<div v-for="(_, i) in editDevice.lines" :key="i" class="margin-t10 mb-5 w-full">
									<div class="flex w-full flex-row">
										<div class="w-full md:w-1/2">
											<form-field
												:label="'Line #' + (i + 1)"
												has-icon
												icon-class="fa-chevron-down"
												class="w-full px-2"
											>
												<select v-model="editDevice.lines[i].sipTrunkId">
													<option disabled :value="null">-- Select SIP Trunk --</option>
													<option v-for="t in tenantSipTrunks" :key="t.id" :value="t.id">
														{{ t.username }}{{ t.description ? ` (${t.description})` : '' }}
													</option>
												</select>
											</form-field>
										</div>
										<div v-if="editDevice.lines?.length > 1" class="px-2 pt-5">
											<button class="fab fabSm red" @click="removeLine(i)">
												<span class="fa-light fa-minus"></span>
											</button>
										</div>
									</div></div
							></form-section>
							<div class="row items-center justify-center">
								<action-buttons
									:disabled="!editDevice.mac || !editDevice.template || !editDevice.tenant || loading"
									:save-label="editDevice.id ? 'Save' : 'Create'"
									@save="save"
									@close="routeTo('/devices')"
								/>
							</div>
						</template>
					</card-wrapper>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import devicesApi from '../scripts/devices/devices.api.js'
import deviceTemplatesApi from '../scripts/devicetemplates/devicetemplates.api.js'
import sipTrunksApi from '../scripts/siptrunks/siptrunks.api.js'
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'tenants'],
	data() {
		return {
			editDevice: {
				mac: '',
				serial_number: '',
				description: '',
				provisioning_password: '',
				tenant: null,
				firmware_url: '',
				lines: [
					{
						sipTrunkId: null
					}
				],
				template: null,
				enabled: true
			},
			loading: true,
			showPassword: false,
			templates: [],
			sipTrunks: [],
			supportedCodecs: ['PCMA', 'PCMU', 'G722', 'OPUS']
		}
	},

	computed: {
		tenantTemplates() {
			return this.templates.filter((t) => t.tenant?.id === this.editDevice.tenant?.id)
		},
		tenantSipTrunks() {
			return this.sipTrunks.filter((t) => t.tenant?.id === this.editDevice.tenant?.id)
		}
	},

	async created() {
		try {
			this.templates = (await deviceTemplatesApi.getAll()).data?.results
			this.sipTrunks = (await sipTrunksApi.getAll()).data?.results

			if (this.$route.params.id !== 'new') {
				const result = await devicesApi.getById(this.$route.params.id)
				this.editDevice = result.data
				this.loading = false

				if (this.editDevice.template)
					this.editDevice.template = this.templates.find((t) => t.id === this.editDevice.template.id)
			} else if (this.tenants?.length === 1) {
				this.editDevice.tenant = this.tenants[0]
			}

			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading device',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/devices')
			})
			console.error(e)
		}
	},

	methods: {
		removeLine(i) {
			this.editDevice.lines.splice(i, 1)
		},
		addLine() {
			if (!this.editDevice.lines) {
				this.editDevice.lines = []
			}
			this.editDevice.lines.push({
				sipTrunkId: null
			})
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			if (!this.editDevice.id) {
				devicesApi
					.create(this.editDevice)
					.then(() => {
						this.routeTo('/devices')
					})
					.catch(console.error)
			} else {
				devicesApi
					.update(this.editDevice)
					.then(() => {
						this.routeTo('/devices')
					})
					.catch(console.error)
			}
		},
		viewTemplate() {
			if (this.editDevice.template?.id) {
				router.push(`/devicetemplates/${this.editDevice.template.id}`)
			}
		},
		createTemplate() {
			router.push('/devicetemplates/new')
		}
	}
}
</script>
